import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useFixedExpenseData} from "../../hooks/useFixedExpenseData";
import {getDataFresh, getDepartmentsData, getFixedExpensesData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import { Box, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import NewFixedExpense from "./NewFixedExpense";
import axios from "axios";
import {createSetDataFreshAction, createSetFixedExpenseDataAction} from "../../actions/dataActions";
import FixedExpenseRow from "./FixedExpenseRow";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import Nav from "../Nav/Nav";
import {ToastContainer, toast} from "react-toastify";
import PaginationWrapper from "../Utils/PaginationWrapper";


export default function FixedExpense(props){
    const [page, setPage] = useState(1);
    const [selectedDepartment, setSelectedDepartment] = useState();
    const [filters, setFilters] = useState({});
    const dispatch = useDispatch();
    const dataFresh = useSelector(getDataFresh);



    const headings = [
        {
            label: "Department",
            field: "department",
            labelField: "department__name"
        },
        {
            label: "Supplier",
            field: "supplier",
            labelField: "supplier__display_name"
        },
        {
            label: "Description"
        },
        {
            label: "Start Date"
        },
        {
            label: "Renewal Date"
        },
        {
            label: "Yearly Amount"
        },
        {
            label: ""
        }
    ]

    let params = {page, page_size:25}

    if(selectedDepartment){
        params.department = selectedDepartment;
    }

    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }

    let dataLoaded = useFixedExpenseData(params, dataFresh);
    let departmentsLoaded = useDepartmentsData({}, dataFresh);

    let data = useSelector(getFixedExpensesData);
    let departments = useSelector(getDepartmentsData);

    if(!dataLoaded || !departmentsLoaded){
        return (
            <div>
                <Nav/>
                <LoadingSpinner/>
            </div>
        )
    }
    const departmentObjects = departments.results.reduce((obj, item) => {
        return {
            ...obj,
            [item["id"]]: item
        };
    }, {});





    const onSave = (data) => {
        let additionalUrl = data.id ? 'fixedexpense/'+data.id : 'fixedexpense'
        const url = props.endpoint+additionalUrl;
        const conf = {
            url,
            method: data.id ? "put" : "post",
            data
        };

        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            setPage(1);
        }).catch(err => {
            toast.error("There was an error saving", {position: "top-right"});
        });
    };

    const onDelete = (data) => {
        const conf = {
            url: props.endpoint+"fixedexpense/"+data.id,
            method: "delete"
        }
        axios(conf).then(res => {
            setPage(1);
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error deleting", {position: "top-right"});
        });
    };

    const onChange = (e, index) => {
        let newResults = [...data.results]
        let newState = {...data, results: newResults};
        let newData = {...data.results[index], [e.target.name]: e.target.value};
        newState.results[index] = newData
        dispatch(createSetFixedExpenseDataAction(newState));
    }

    const onDepartmentChange = e => {
        setSelectedDepartment(e.target.value);
    }

    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <dix>
            <Nav/>
            <br/>
            <br/>
            <NewFixedExpense onSave={onSave} departments={departments} departmentObjects={departmentObjects}/>
            <Box>
                <Title>Fixed Expenses</Title>
                <Columns isMultiline>
                    <Column>
                        <DepartmentPicker
                            selectedDepartment={selectedDepartment}
                            departments={departments}
                            onDepartmentChange={onDepartmentChange}
                        />
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Table isFullwidth>
                            <thead>
                                <tr>
                                    {headings.map(heading => {
                                        if (!heading.field) {
                                          return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                                        }
                                        if (heading.blank) {
                                          return (
                                            <FilterBlankHeading
                                              key={heading.label}
                                              heading={heading}
                                              setFilters={f => {
                                                setPage(1);
                                                setFilters(f);
                                              }}
                                              filters={filters}
                                              className={heading.className}
                                              thClass={heading.thClass}
                                            />
                                          );
                                        }
                                        return (
                                          <FilterHeading
                                            key={heading.label}
                                            heading={heading}
                                            setFilters={f => {
                                              setPage(1);
                                              setFilters(f);
                                            }}
                                            filters={filters}
                                            options={data.filter_list[heading.field]}
                                            className={heading.className}
                                            thClass={heading.thClass}
                                          />
                                        );
                                      })}
                                </tr>
                            </thead>
                            <tbody>
                            {data.results.map((fixedExpense, index) => (
                                <FixedExpenseRow
                                    fixedExpense={fixedExpense}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onDelete={onDelete}
                                    index={index}
                                    departments={departments}
                                    departmentObjects={departmentObjects}
                                />
                            ))}
                            </tbody>
                        </Table>
                        <PaginationWrapper
                          setPage={setPage}
                          page={page}
                          dataCount={Math.ceil(data ? data.count / 25 : 0)}
                        ></PaginationWrapper>
                    </Column>
                </Columns>
            </Box>
        </dix>
    );


}